import { ChangeDetectionStrategy, Component, OnInit, computed, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { WhitelabeledComponentKey } from '../../../../../whitelabel/whitelabel-component-types';
import { Authorities } from '../../../../shared/enums/authorities.enum';
import { Modules } from '../../../../shared/enums/modules.enum';
import { ComponentPlaceholderComponent } from '../../../../whitelabel/components/component-placeholder/component-placeholder.component';
import { CreateNewEntityButtonComponent } from './create-new-entity-button/create-new-entity-button.component';
import { WhitelabeledComponent } from '../../../../whitelabel/components/whitelabeled-component/whitelabeled-component.component';
import { ThemeService } from '../../../../whitelabel/services/theme.service';
import { AuthService } from '../../../services/auth.service';
import { AutomatedTransfersNotificationsCenterOverlayComponent } from './automated-transfers-notifications-center-overlay/automated-transfers-notifications-center-overlay.component';
import { EquipmentAttentionOverlayComponent } from './equipment-attention-overlay/equipment-attention-overlay.component';
import { HelpOverlayComponent } from './help-overlay/help-overlay.component';
import { NotificationsCenterOverlayComponent } from './notifications-center-overlay/notifications-center-overlay.component';
import { CanSeeAutomatedTransfersOverlayService } from './services/can-see-automated-transfers-overlay.service';
import { UserSettingsMenuComponent } from './user-settings-menu/user-settings-menu.component';

@Component({
  selector: 'osp-topbar',
  standalone: true,
  imports: [
    HelpOverlayComponent,
    NotificationsCenterOverlayComponent,
    EquipmentAttentionOverlayComponent,
    WhitelabeledComponent,
    AutomatedTransfersNotificationsCenterOverlayComponent,
    RouterLink,
  ],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopbarComponent implements OnInit {
  private authService = inject(AuthService);
  private canSeeAutomatedTransfersOverlayService = inject(CanSeeAutomatedTransfersOverlayService);
  private readonly themeService = inject(ThemeService);

  private readonly $theme = toSignal(this.themeService.theme$, { initialValue: this.themeService.getCurrentTheme() });
  readonly $logo = computed(() => this.themeService.getTheme(this.$theme()).images.logoFull);

  readonly $canSeeAutomatedTransfersNotificationsOverlay = this.canSeeAutomatedTransfersOverlayService.$canSee;
  readonly $canSeeNotifications = signal(
    this.authService.hasAuthority(Authorities.NOTIFICATIONS_VIEW_ALARMS) && this.authService.hasModule(Modules.ALARMS),
  );
  readonly $canSeeAttention = signal(this.authService.hasAuthority(Authorities.EQUIPMENT_VIEW));
  protected readonly WhitelabeledComponentKey = WhitelabeledComponentKey;
  protected readonly ComponentPlaceholderComponent = ComponentPlaceholderComponent;
  protected readonly UserSettingsMenuComponent = UserSettingsMenuComponent;
  protected readonly CreateNewEntityButtonComponent = CreateNewEntityButtonComponent;

  ngOnInit(): void {
    this.canSeeAutomatedTransfersOverlayService.setVisibility();
  }
}
